import React from 'react';
import { Button } from 'components';
import { withStyles, createStyleSheet } from 'material-ui/styles';

const styleSheet = createStyleSheet('FAB', () => ({
  button: {
    position: 'fixed',
    bottom: 32,
    right: 32,
    zIndex: 100,
  },
}));

const FAB = ({ classes, ...props }) => {
  return <Button fab color="accent" className={classes.button} {...props} />;
};

export default withStyles(styleSheet)(FAB);



// WEBPACK FOOTER //
// ./src/common/components/FAB.js